export default {"src":"/_next/static/media/contact-us.75207d16.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};